const HeaderShadowSeparator = ({ css = "" }) => {

    const cssDiv = `absolute w-full h-1 -top-[0vh] shadow-md shadow-ivory ${css}`

    return (
        <div className={cssDiv} />
    )
}

export default HeaderShadowSeparator